/**
 * POSTs a frontend error to the backend, which forwards it to Sentry.
 * Same idea as the ui_extension_errored Shopify pixel.
 *
 * Constructor (and any other FE code) calls:
 *   window.reportFrontendError({ source, surface, message, stack, error_type, context })
 */
(function () {
  const URL = window.errorMonitoringUrl;
  if (!URL || window.Shopify?.designMode) {
    window.reportFrontendError = function () {};
    return;
  }

  let sent = 0;

  window.reportFrontendError = function reportFrontendError(input) {
    if (!input || sent >= 8) return;
    sent += 1;

    try {
      fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Shop-Domain': window.shopDomain || '',
          ...(URL.includes('ngrok') ? { 'ngrok-skip-browser-warning': '1' } : {}),
        },
        body: JSON.stringify({
          ...input,
          url: window.location.href,
          user_agent: navigator.userAgent,
        }),
        keepalive: true,
      }).catch(function () {});
    } catch (_) {}
  };
})();
